<template>
  <div>
    <div v-if="live.id" class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">پخش‌ فعال</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="">
              <div class="d-flex flex-column flex-root">
                <span class="font-weight-bolder mb-2">شروع</span>
                <span class="opacity-70 text-nowrap" dir="ltr">
                  {{ formatDate(live.created_at) }}
                </span>
              </div>

              <div class="d-flex flex-column flex-root mt-4">
                <span class="font-weight-bolder mb-2">مدت</span>
                <span class="opacity-70 text-nowrap" dir="ltr">
                  <span class="timer">{{ prettyTime(activeLiveTime) }}</span>
                </span>
              </div>
              <div v-if="isAdmin" class="d-flex flex-column flex-root mt-4">
                <span class="font-weight-bolder mb-2">سرور</span>
                <span class="opacity-70 text-nowrap font-family-base" dir="ltr">
                  {{ live.server }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <PlayerComp :live="program"></PlayerComp>
          </div>
        </div>
        <div v-if="fActiveLiveDestinations.length" class="mt-5">
          <div class="font-weight-bolder mb-4 mt-10">مقصد‌ها</div>
          <TableComp :liveDestinations="fActiveLiveDestinations"></TableComp>
        </div>
      </div>
    </div>
    <div v-show="fLives.length" class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">پخش‌ها</h3>
        </div>
        <div class="card-toolbar">
          <div v-show="!livesLoaded" class="spinner mr-3"></div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th class="pl-10">شروع</th>
                <th>پایان</th>
                <th>مدت</th>
                <th>وضعیت</th>
                <th>توضیحات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="li in fLives" :key="`live-${li.id}`">
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: isCompany ? 'company-lives-show' : 'lives-show',
                      params: {
                        program: $route.params.id,
                        live: li.id
                      }
                    }"
                  >
                    <span class="label" :class="li.labelClass">
                      <span class="position-relative" v-html="li.icon"></span>
                      <span class="pulse-ring"></span>
                    </span>
                    <span dir="ltr" class="text-nowrap">
                      {{ formatDate(li.start) }}
                    </span>
                  </router-link>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(li.end) }}
                </td>
                <td dir="ltr">{{ li.length }}</td>
                <td dir="ltr" class="text-nowrap">
                  <span
                    v-if="li.labelClass === 'pulse pulse-danger label-danger'"
                    class="font-family-base"
                  >
                    درحال پخش
                  </span>
                  <span
                    v-if="li.labelClass === 'label-warning'"
                    class="font-family-base"
                  >
                    پایان لینک یا استریم ورودی
                  </span>
                  <span
                    v-if="li.labelClass === 'label-danger'"
                    class="font-family-base"
                  >
                    خطا
                  </span>
                  <span
                    v-if="li.labelClass === 'label-primary'"
                    class="font-family-base"
                  >
                    موفق
                  </span>
                </td>
                <td class="text-danger text-nowrap">{{ li.error }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="overflow-auto mt-5" v-if="livesPagination.lastPage > 1">
          <b-pagination
            v-model="livesPagination.currentPage"
            :total-rows="livesPagination.total"
            :per-page="livesPagination.perPage"
            @input="updateLives()"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_LIVES,
  FETCH_LIVE,
  FETCH_LIVE_DESTINATIONS,
  SET_LIVE,
  STOP_LIVE,
  FETCH_LIVE_DESTINATION_VIEWERS
} from "@/core/services/store/lives.module";
import { START_PROGRAM } from "@/core/services/store/programs.module";
import {
  ADD_ACTIONS,
  REMOVE_BUTTON_ACTIONS
} from "@/core/services/store/actions.module";
import Swal from "sweetalert2";
import instagram from "@/core/mixins/instagram";
import XLSX from "xlsx";
import PlayerComp from "@/view/pages/programs/comp/PlayerComp.vue";
import TableComp from "@/view/content/TableComp.vue";

export default {
  name: "ProgramLives",
  mixins: [instagram],
  props: {
    program: Object
  },
  data() {
    return {
      loaded: false,
      livesLoaded: false,
      liveInterval: null,
      connection: null,
      activeLiveTime: 0,
      timer: null,
      checkButtons: true,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      labels: {
        0: "pulse pulse-danger label-danger",
        1: "label-warning",
        2: "label-danger",
        3: "label-primary",
        4: "label-warning"
      },
      icons: {
        0: '<i class="far fa-1x fa-play pt-1 text-white"></i>', //started
        1: '<i class="far fa-1x fa-circle pt-1 text-white"></i>', //finished
        2: '<i class="far fa-1x fa-exclamation pt-1 text-white"></i>', //failed
        3: '<i class="far fa-1x fa-stop pt-1 text-white"></i>', //stopped by user
        4: '<i class="far fa-1x fa-stop pt-1 text-white"></i>' //stopped by company
      }
    };
  },
  components: {
    PlayerComp,
    TableComp
  },
  mounted() {
    this.$store.commit(SET_LIVE, {});
    this.getLives();

    this.liveInterval = setInterval(() => {
      this.getLives();
    }, 8000);
  },
  beforeDestroy: function() {
    this.eventHub.$off(["start-program-event"]);
    this.eventHub.$off(["stop-program-event"]);
    clearInterval(this.liveInterval);
    this.liveInterval = null;
  },
  watch: {
    live: function() {
      this.setButtons();
    }
  },
  computed: {
    ...mapGetters([
      "lives",
      "livesPagination",
      "live",
      "liveDestinations",
      "destinationTypes",
      "liveDestinationsViewers"
    ]),

    fLives() {
      let data = [];

      this.lives.forEach(live => {
        let end = undefined,
          labelClass = this.labels[0],
          length = "-",
          error = "",
          icon = this.icons[0];

        if (live.events !== undefined) {
          if (live.events[0] !== undefined) {
            end = live.events[0].created_at ?? undefined;
            length = live.events[0].details.length
              ? this.prettyTime(live.events[0].details.length)
              : "-";
            error = live.events[0].details.error ?? "";
            labelClass = this.labels[live.events[0].type];
            icon = this.icons[live.events[0].type];
          } else {
            length = this.prettyTime(this.getDuration(live.created_at));
          }
        } else {
          length = this.prettyTime(this.getDuration(live.created_at));
        }
        data.push({
          id: live.id,
          start: live.created_at,
          end: end,
          labelClass: labelClass,
          length: length,
          error: error,
          icon: icon
        });
      });

      return data;
    },
    fActiveLiveDestinations() {
      let data = [];
      let badges = {
        0: "badge-danger",
        1: "badge-warning",
        2: "badge-danger",
        3: "badge-primary",
        4: "badge-warning"
      };

      this.liveDestinations.forEach(liveDestination => {
        if (liveDestination.destination) {
          let name = liveDestination.destination.name ?? "";
          let image = `/media/destinations/${
            this.destinationTypes[liveDestination.destination.type]
          }.png`;

          let start = liveDestination.created_at,
            end = undefined,
            length = this.prettyTime(
              this.getDuration(liveDestination.created_at)
            ),
            error = "",
            badge = "badge-success";
          if (
            liveDestination.events !== undefined &&
            liveDestination.events[0] !== undefined
          ) {
            end = liveDestination.events[0].created_at;
            length = liveDestination.events[0].details.length
              ? this.prettyTime(liveDestination.events[0].details.length)
              : "-";
            error = liveDestination.events[0].details.error ?? "";
            badge = badges[liveDestination.events[0].type]
              ? badges[liveDestination.events[0].type]
              : "";
          }

          data.push({
            id: liveDestination.id,
            live_id: liveDestination.live_id,
            type: liveDestination.destination.type,
            last_event: liveDestination.last_event,
            comment_status: liveDestination.destination.details.comment_status,
            destination: liveDestination.destination,
            name: name,
            image: image,
            badge: badge,
            start: this.formatDate(start),
            end: this.formatDate(end),
            length: length,
            error: error
          });
        }
      });
      this.sortArray(data);

      return data;
    }
  },
  methods: {
    download(id) {
      this.updateLiveDestinationViewers(id);
      if (this.liveDestinationsViewers.length > 0) {
        const listViewers = this.liveDestinationsViewers.map(item => {
          return {
            نام: item.full_name,
            "نام کاربری": item.username
          };
        });
        const data = XLSX.utils.json_to_sheet(listViewers);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, data, "data");
        XLSX.writeFile(wb, "list.xlsx");
      } else {
        Swal.fire({
          title: "",
          text: "تا این لحظه ای بازدیدکننده ای وجود ندارد!",
          icon: "error",
          showCloseButton: false,
          confirmButtonText: "بستن",
          confirmButtonColor: "#4554a0",
          heightAuto: false
        });
      }
    },
    sortArray(items) {
      items.sort(function(a, b) {
        return a.last_event - b.last_event;
      });
    },
    handleComments(destination) {
      Swal.fire({
        title: "",
        text: "آیا مطمئن هستید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.handleCommentInstagram(destination);
        }
      });
    },
    getLives() {
      this.livesLoaded = false;
      this.$store.dispatch(FETCH_LIVES, this.program.id).then(() => {
        this.livesLoaded = true;

        if (this.livesPagination.currentPage === 1) {
          if (this.live.length) {
            this.getActiveLive(this.live);
          } else {
            let live = this.lives[0];
            if (live) {
              this.getActiveLive(live);
            }
          }
        } else {
          let live = this.lives[0];
          if (live) {
            this.getActiveLive(live);
          }
        }

        if (this.checkButtons) {
          this.setButtons();
          this.checkButtons = false;
        }
      });
    },
    getActiveLive(live) {
      if (live.id && this.liveIsStreaming(live)) {
        this.$store.dispatch(FETCH_LIVE, live.id).then(() => {
          this.activeLiveTime = this.getDuration(this.live.created_at);
          this.startTimer();

          if (this.checkButtons) {
            this.setButtons();
            this.checkButtons = false;
          }
        });
        this.$store.dispatch(FETCH_LIVE_DESTINATIONS, live.id);
      } else {
        this.$store.commit(SET_LIVE, {});
      }
    },
    updateLives() {
      this.livesLoaded = false;

      this.$store
        .dispatch(FETCH_LIVES, this.$route.params.id)
        .then(() => {
          this.livesLoaded = true;
        })
        .catch(() => {
          this.livesLoaded = true;
        });
    },
    setButtons() {
      let startBtn = {
        name: '<i class="flaticon2-arrow"></i>شروع',
        event: "start-program-event",
        class: "btn-success",
        id: "start-program-btn"
      };
      let stopBtn = {
        name: '<i class="fas fa-stop"></i>توقف',
        event: "stop-program-event",
        class: "btn-danger",
        id: "stop-program-btn"
      };

      let buttons = [];
      if (this.program.type !== 1 && this.live.id === undefined) {
        buttons.push(startBtn);
      } else {
        this.$store.commit(REMOVE_BUTTON_ACTIONS, startBtn);
      }
      if (
        this.live.id &&
        !this.isProgramStopped(this.program) &&
        !this.isProgramFailed(this.program)
      ) {
        buttons.push(stopBtn);
      } else {
        this.$store.commit(REMOVE_BUTTON_ACTIONS, stopBtn);
      }

      this.$store.dispatch(ADD_ACTIONS, {
        buttons: buttons
      });

      this.eventHub.$on("start-program-event", this.start);
      this.eventHub.$on("stop-program-event", this.stop);
    },
    start() {
      Swal.fire({
        title: "",
        text: "آیا برنامه شروع شود؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          let startBtn = document.getElementById("start-program-btn");
          this.disableBtn(startBtn);

          this.$store
            .dispatch(START_PROGRAM, this.program.id)
            .then(() => {
              this.getLives();
              this.checkButtons = true;
              this.enableBtn(startBtn);
            })
            .catch(() => {
              this.enableBtn(startBtn);
            });
        }
      });
    },
    stop() {
      Swal.fire({
        title: "",
        text: "آیا از توقف برنامه‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          let stopBtn = document.getElementById("stop-program-btn");
          this.disableBtn(stopBtn);

          this.$store
            .dispatch(STOP_LIVE, this.live.id)
            .then(() => {
              this.getLives();
              this.checkButtons = true;
              this.enableBtn(stopBtn);
            })
            .catch(() => {
              this.enableBtn(stopBtn);
            });
        }
      });
    },
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.activeLiveTime++;
        }, 1000);
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.activeLiveTime = 0;
    },
    liveIsStreaming(live) {
      return live.last_event === 0;
    },
    webSocket() {
      // this.connection = new WebSocket(this.live.server);
      // this.connection.onmessage = function (event) {
      // console.log(event);
      // };
      // this.connection.onopen = function (event) {
      // console.log(event);
      // console.log("Successfully connected.");
      // };
    },
    updateLiveDestinationViewers(id) {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_LIVE_DESTINATION_VIEWERS, id)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
